// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'

export var BuyingPowerAvailableFundsForOptionsBuyGroup = function (pfixFieldSet)    
{
    PFixFieldSet.call(this, FieldsFactory.BUYING_POWER_AVAILABLE_FUNDS_FOR_OPTIONS_BUY, null, pfixFieldSet)
}
BuyingPowerAvailableFundsForOptionsBuyGroup.prototype = Object.create(PFixFieldSet.prototype)

BuyingPowerAvailableFundsForOptionsBuyGroup.prototype.getBuyingPowerName = function ()
{
    return this.GetValue(FieldsFactory.FIELD_NAME)
}

BuyingPowerAvailableFundsForOptionsBuyGroup.prototype.getAvailableMargin = function ()
{
    return this.GetValue(FieldsFactory.FIELD_AVAILABLE_MARGIN)
}